import { axisBottom, select } from "d3";
import { margin } from "./constants";
import { DrawParams } from "./types";

const maxTicks = [
  20, 30, 40, 50, 70, 100, 200, 300, 500, 700, 1000, 2000, 3000, 4000, 5000,
  7000, 10000, 20000,
];

const reducedTicks = [20, 50, 100, 300, 700, 2000, 5000, 10000, 20000];

export default function drawAxis({
  contentHeight,
  xScale,
  svg,
  contentWidth,
}: DrawParams) {
  const axisGenerator = axisBottom(xScale)
    .tickSize(contentHeight - margin.top - margin.bottom)
    .tickValues(contentWidth > 700 ? maxTicks : reducedTicks)
    .ticks(20);

  const xAxis = svg
    .selectAll("g.axis")
    .data([{}])
    .join("g")
    .attr("class", "axis select-none")
    .call(axisGenerator as any); // couldn't get this type to work after many tries

  xAxis.attr("transform", `translate(0,${margin.top})`);

  // Add black bg
  xAxis
    .selectAll(".tick text")
    .filter(function () {
      return !!select(this).text();
    })
    .select(function () {
      // this is a TS type hack but it works
      // `this` is an SVGTextElement
      return (this as any)?.parentNode;
    })
    .insert("rect", "text")
    .attr("class", "tickBg")
    .attr("fill", "black")
    .attr("width", 30)
    .attr("height", 30)
    .attr("x", -15)
    .attr("y", contentHeight - 40);

  xAxis.select(".domain").remove();
  xAxis
    .selectAll(".tick text")
    .attr("class", "font-rogan text-xs fill-white")
    .attr("y", contentHeight - 30)
    .attr("background", "black");

  xAxis.selectAll(".tick line").attr("class", "fill-none stroke-white/25");
}
